/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="115.28"
        height="59.49"
        viewBox="0 0 115.28 59.49"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M21.96.18a1.25 1.25 0 0 1 1.24 1.26 1.23 1.23 0 0 1-1.09 1.23H1.32A1.25 1.25 0 0 1 0 1.49 1.27 1.27 0 0 1 1.19.17h20.77ZM17.96 12.09a1.26 1.26 0 0 1 1.31 1.2 1.25 1.25 0 0 1-1.19 1.31H1.32a1.26 1.26 0 1 1-.13-2.51ZM13.4 23.85a1.25 1.25 0 0 1 1.22 1.28 1.23 1.23 0 0 1-1.09 1.21H1.32a1.25 1.25 0 0 1-.13-2.49ZM7.36 35.5a1.25 1.25 0 0 1 1.22 1.28 1.23 1.23 0 0 1-1.09 1.21H1.32A1.25 1.25 0 0 1 0 36.81a1.27 1.27 0 0 1 1.19-1.32h6.17Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M110.76 0h-75.8a4.45 4.45 0 0 0-4.41 3.85l-7 50.58a4.44 4.44 0 0 0 3.8 5 3.82 3.82 0 0 0 .68 0h75.76a4.45 4.45 0 0 0 4.41-3.85l7-50.58a4.47 4.47 0 0 0-3.82-5c-.18.02-.42 0-.62 0Zm-75.8 2.5h75.8a2 2 0 0 1 1.94 2.06.81.81 0 0 1 0 .16l-7 50.58a2 2 0 0 1-1.93 1.69h-75.7a2 2 0 0 1-2-2 1.93 1.93 0 0 1 0-.24l7-50.58a2 2 0 0 1 1.89-1.67Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="m33.07.36 34.55 33.53 44.71-32.64 1.47 2-45.55 33.29a1.25 1.25 0 0 1-1.51 0l-.1-.09-35.3-34.29Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M74.96 29.72 105.89 56l-1.62 1.91-30.93-26.29ZM62.44 29.33l1.46 2-37 26.61-1.46-2Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'EnvelopeMovingIcon';

export default Icon;
